import { createReducer } from 'reduxsauce'

import { Types } from './actions'
import { INITIAL_STATE, INITIAL_VALUES } from './initialState'

export const firebaseListenRequested = (state, action) => {
  const property = action.metaType
  const propertyState = state[property]

  const newState = {
    ...state,
    [property]: { ...propertyState, loading: true, error: '' },
  }

  return newState
}

export const firebaseListenFulfilled = (state, action) => {
  const property = action.metaType
  const propertyState = state[property]
  const items = {
    ...INITIAL_VALUES[property],
    ...action.items,
  }

  const newState = {
    ...state,
    [property]: { ...propertyState, loading: false, error: '', items },
  }

  return newState
}

export const firebaseListenRejected = (state, action) => {
  const property = action.metaType
  const propertyState = state[property]
  const { error } = action

  const newState = {
    ...state,
    [property]: { ...propertyState, loading: false, error },
  }

  return newState
}

export const firebaseListenChildUpdated = (state, action) => {
  const property = action.metaType
  const propertyState = state[property]
  const items = {
    ...INITIAL_VALUES[property],
    ...action.value,
  }

  const newState = {
    ...state,
    [property]: { ...propertyState, loading: false, error: '', items },
  }

  return newState
}

export const firebaseListenRemoved = (state, action) => {
  const property = action.metaType
  const propertyState = state[property]
  const items = action.clearItems ? {} : propertyState.items

  const newState = {
    ...state,
    [property]: { ...propertyState, loading: false, error: '', items },
  }

  return newState
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FIREBASE_LISTEN_REQUESTED]: firebaseListenRequested,
  [Types.FIREBASE_LISTEN_REJECTED]: firebaseListenRejected,
  [Types.FIREBASE_LISTEN_FULFILLED]: firebaseListenFulfilled,
  [Types.FIREBASE_LISTEN_CHILD_UPDATED]: firebaseListenChildUpdated,
  [Types.FIREBASE_LISTEN_REMOVED]: firebaseListenRemoved,
})
